<template lang="pug">
#laudos
    p {{ $t('mensagens.laudos.sigaEtapasAbaixoParaContinuarComSolicitacao') }}
    slot
        .modal-container-inner-filtros
        .filtro-tipo-consulta
            SelecionarEtapasLaudo(@cancelar-modal='changeShowModalSelecionarTerritorio', :tipoLaudo='tipoLaudo')

</template>

<script>
import SelecionarEtapasLaudo from '@/components/laudos/SelecionarEtapasLaudo.vue';
import TipoLaudo from '@/constants/TipoLaudo';
import LaudoService from '@/services/LaudosService';
import { mapGetters } from 'vuex';

export default {
    name: 'LaudoAnaliseCoberturaSoloModal',
    components: {
        SelecionarEtapasLaudo
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO,
            showModalVisualizacao: false,
            showModalSelecionarTerritorios: false,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                statusId: '',
                car: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO
            },
            totalLaudos: 0,
            laudos: [],
            idLaudo: null,
            rowInfo: null,
            showModalInsercaoResultados: false,
            usuariosBuffer: {},
            loading: false,
            isLaudoUnico: false,
            tipoBusca: 'CAR'
        };
    },
    methods: {
        async getLaudos() {
            await this.requestLaudos();
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;

            this.$emit('showModalSelecionarTerritorios');
        },

        changeShowModalConfirmarTerritorios() {
            this.showModalConfirmarTerritorios =
                !this.showModalConfirmarTerritorios;
        },

        solicitarLaudos(territoriosSelecionados) {
            this.changeShowModalSelecionarTerritorio();
            this.changeShowModalConfirmarTerritorios();
            this.territoriosSelecionados = territoriosSelecionados;
            this.$emit('atualizarTerritoriosSelecionados', this.territoriosSelecionados);
        },

        voltar() {
            this.changeShowModalConfirmarTerritorios();
            this.getLaudos();
        },
        handleModalLaudo(laudo) {
            this.showModalVisualizacao = !this.showModalVisualizacao;
            this.idLaudo = laudo;
        },
        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.getLaudos();
        },
        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },
        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.getLaudos();
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.naoFoiPossivelCarregarOsDados')
                });
            } finally {
                this.loading = false;
            }
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        },

        onChangeHandle() {
            this.showBusca();
        },

        showBusca() {
            if (this.tipoBusca === 'CAR') {
                $('#idTerritorio').addClass('none');
                $('#idVetor').addClass('none');
                $('#idCar').removeClass('none');
            } else if (this.tipoBusca === 'TERRITORIO') {
                $('#idCar').addClass('none');
                $('#idVetor').addClass('none');
                $('#idTerritorio').removeClass('none');
            } else {
                $('#idCar').addClass('none');
                $('#idTerritorio').addClass('none');
                $('#idVetor').removeClass('none');
            }
        },

        desabilitarTerritorio(usuarioLogado) {
            if (usuarioLogado && usuarioLogado.authorities.length > 1) {
                return false;
            } else {
                if (usuarioLogado.authorities[0].authority === 'ROLE_FEATURE_LAUDO') {
                    return true;
                }
                return false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
#laudos {
    p {
        padding-top: 10px !important;
    }
    .laudo-margin {
        margin-bottom: 20px;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .radio-group-container {
        max-width: 250px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .radio-button {
        margin-right: 20px !important;
    }

    .none {
        display: none !important;
    }
}
</style>
